<template>
  <div id="app">
    <el-container>
      <el-header>
        <div class="header-content">
          <div class="logo-section">
            <div class="logo">
              <el-icon size="28" color="#409EFF"><Link /></el-icon>
            </div>
            <div class="title-section">
              <h1>智能链接聚合平台</h1>
              <p class="subtitle">高效管理，精准分发</p>
            </div>
          </div>
          <div class="header-actions">
            <el-button type="primary" @click="refreshData" circle>
              <el-icon><Refresh /></el-icon>
            </el-button>
            <el-button type="info" @click="showHelp" circle>
              <el-icon><QuestionFilled /></el-icon>
            </el-button>
            <el-dropdown @command="handleUserCommand" v-if="currentUser">
              <el-button type="text" class="user-dropdown">
                <el-icon><User /></el-icon>
                {{ currentUser.username }}
                <el-icon class="el-icon--right"><ArrowDown /></el-icon>
              </el-button>
              <template #dropdown>
                <el-dropdown-menu>
                  <el-dropdown-item command="logout">
                    <el-icon><SwitchButton /></el-icon>
                    退出登录
                  </el-dropdown-item>
                </el-dropdown-menu>
              </template>
            </el-dropdown>
          </div>
        </div>
      </el-header>
      
      <el-main>
        <router-view />
      </el-main>
      
      <el-footer>
        <div class="footer-content">
          <p>&copy; 2024 智能链接聚合平台. 让链接管理更简单</p>
        </div>
      </el-footer>
    </el-container>
  </div>
</template>

<script>
import { ref, onMounted } from 'vue'
import { useRouter } from 'vue-router'
import { ElMessage, ElMessageBox } from 'element-plus'
import { auth } from './utils/auth'

export default {
  name: 'App',
  setup() {
    const router = useRouter()
    const currentUser = ref(null)
    
    // 获取当前用户信息
    const getUserInfo = () => {
      currentUser.value = auth.getCurrentUser()
    }
    
    // 刷新数据
    const refreshData = () => {
      ElMessage.success('数据已刷新')
    }
    
    // 显示帮助
    const showHelp = () => {
      ElMessage.info('帮助文档功能开发中...')
    }
    
    // 处理用户下拉菜单命令
    const handleUserCommand = async (command) => {
      if (command === 'logout') {
        try {
          await ElMessageBox.confirm(
            '确定要退出登录吗？',
            '确认退出',
            {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning',
            }
          )
          
          auth.logout()
          currentUser.value = null
          ElMessage.success('已退出登录')
          router.push('/login')
        } catch {
          // 用户取消
        }
      }
    }
    
    onMounted(() => {
      getUserInfo()
    })
    
    return {
      currentUser,
      refreshData,
      showHelp,
      handleUserCommand
    }
  }
}
</script>

<style>
#app {
  font-family: 'PingFang SC', 'Microsoft YaHei', Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  min-height: 100vh;
}

.el-header {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  line-height: 60px;
  padding: 0;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  height: 70px !important;
}

.header-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  margin: 0;
  padding: 0 20px;
  height: 100%;
  overflow: visible;
}

.logo-section {
  display: flex;
  align-items: center;
  gap: 15px;
  flex-shrink: 0;
}

.logo {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 12px;
  backdrop-filter: blur(10px);
}

.title-section h1 {
  margin: 0;
  font-size: 24px;
  font-weight: 600;
  letter-spacing: 0.5px;
}

.subtitle {
  margin: 0;
  font-size: 12px;
  opacity: 0.8;
  font-weight: 300;
}

.header-actions {
  display: flex;
  gap: 10px;
  align-items: center;
  flex-shrink: 0;
  min-width: 0;
}

.user-dropdown {
  color: white !important;
  font-size: 14px;
  padding: 8px 12px;
  border-radius: 8px;
  transition: all 0.3s ease;
  white-space: nowrap;
  overflow: visible;
  max-width: none;
  flex-shrink: 0;
}

.user-dropdown.el-button {
  max-width: none !important;
  overflow: visible !important;
}

.user-dropdown:hover {
  background: rgba(255, 255, 255, 0.1);
  color: white !important;
}

.user-dropdown .el-icon {
  margin-right: 5px;
}

.el-main {
  padding: 0;
  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
  min-height: calc(100vh - 130px);
}

.el-footer {
  background: #2c3e50;
  color: white;
  text-align: center;
  line-height: 40px;
  padding: 0;
}

.footer-content {
  width: 100%;
  margin: 0;
  padding: 0 20px;
}

.footer-content p {
  margin: 0;
  font-size: 14px;
  opacity: 0.8;
}

.page-container {
  background: white;
  border-radius: 16px;
  padding: 30px;
  box-shadow: 0 8px 32px 0 rgba(0, 0, 0, 0.1);
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.2);
  width: 100%;
  margin: 0;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .header-content {
    padding: 0 10px;
  }
  
  .title-section h1 {
    font-size: 20px;
  }
  
  .subtitle {
    display: none;
  }
  
  .el-main {
    padding: 0;
  }
  
  .page-container {
    padding: 20px;
    border-radius: 12px;
  }
}
</style>
